import { IUrlSearchClientParams } from '../interfaces/InterfaceData';

export const urlSearchParams = (params: IUrlSearchClientParams) => {
    return Object.entries(params)
        .filter(([key, value]) => value)
        .map((e) => e.join('='))
        .join('&');
};
